// A file keeps its client identity after sync so delayed hydration/batch results
// cannot recreate its pending placeholder. Never match by name: two uploads
// may legitimately have the same filename.
const identities = file => new Set([
  file?._id, file?.id, file?._clientId,
  file?._clientId && `pending_${file._clientId}`,
].filter(Boolean).map(String))

export function mergeFileRecords(files = [], incoming = []) {
  let result = [...files]
  for (const file of incoming) {
    if (!file) continue
    const keys = identities(file)
    const matches = existing => [...identities(existing)].some(key => keys.has(key))
    const existing = result.filter(matches)
    const index = result.findIndex(matches)
    // A stale offline result must never overwrite a completed upload.
    const saved = existing.find(item => !item._offlineQueued)
    const chosen = file._offlineQueued && saved ? saved : file
    const clientId = chosen._clientId || file._clientId || existing.find(item => item._clientId)?._clientId
    const record = clientId ? { ...chosen, _clientId: clientId } : chosen
    result = result.filter(item => !matches(item))
    result.splice(index === -1 ? 0 : index, 0, record)
  }
  return result
}
